"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-CSVImport',
    title: 'c-CSVImport__title',
    message: 'c-CSVImport__message',
    option: {
        container: 'c-CSVImport__option',
        textContainer: 'c-CSVImportOption__text-container',
        text: 'c-CSVImportOption__text',
        value: 'c-CSVImportOption__value',
        importing: 'c-CSVImport__importing',
        download: 'c-CSVImportOption__download',
        downloadDisabled: 'c-CSVImportOption__download--disabled'
    },
    importButton: 'c-CSVImport__button',
    isOptionComplete: 'c-CSVImportOption--is-complete',
    isOptionIconComplete: 'c-CSVImportIcon--is-complete',
    isTooManyCollections: 'c-CSVImport--too-many-collections',
    job: {
        container: 'c-CSVImport__job'
    },
    form: {
        container: 'c-CSVImport__form'
    },
    file: {
        container: 'c-CSVImport__file',
        drop: 'c-CSVImport__drop'
    },
    csv: {
        container: 'c-CSVImport__csv'
    },
    tabBar: {
        container: 'c-Tab-bar',
        tab: 'c-TabBar__tab',
        tabActive: 'c-TabBar__tab--active'
    },
    importNotifications: {
        container: 'c-ImportNotifications',
        collectionLink: 'c-ImportNotifications__collectionLink'
    }
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        width: '80%',
        margin: theme_1.DefaultTheme.space(4),
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2
    },
    _a[exports.CSS.title] = {
        padding: '0 ' + theme_1.DefaultTheme.space(6),
        height: theme_1.DefaultTheme.space(12),
        'line-height': theme_1.DefaultTheme.space(12),
        display: 'flex',
        '& h6': {
            margin: 0,
            'line-height': theme_1.DefaultTheme.space(12)
        }
    },
    _a[exports.CSS.message] = {
        padding: theme_1.DefaultTheme.space(6)
    },
    _a[exports.CSS.option.container] = {
        padding: theme_1.DefaultTheme.space(4),
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between'
    },
    _a[exports.CSS.option.importing + ' .c-Spinner'] = {
        'margin-right': theme_1.DefaultTheme.space(4)
    },
    _a[exports.CSS.option.value] = {
        display: 'flex',
        'align-items': 'center',
        height: theme_1.DefaultTheme.space(10),
        width: '300px'
    },
    _a[exports.CSS.option.textContainer] = {
        'font-size': '120%',
        display: 'flex',
        flex: '1',
        'align-items': 'center',
        padding: theme_1.DefaultTheme.space(1),
        '& i': {
            'padding-right': '16px'
        }
    },
    _a[exports.CSS.option.text] = {
        paddingRight: theme_1.DefaultTheme.space(2),
        '&:only-child': {
            paddingLeft: "calc(".concat(theme_1.DefaultTheme.space(4), " + 24px)")
        }
    },
    _a[exports.CSS.option.download] = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        'font-size': '120%',
        padding: "".concat(theme_1.DefaultTheme.space(2), " ").concat(theme_1.DefaultTheme.space(4)),
        boxSizing: 'border-box',
        border: '1px solid black',
        color: 'black',
        cursor: 'pointer',
        '&:hover': {
            background: theme_1.DefaultTheme.background.lightGrey,
            borderColor: theme_1.DefaultTheme.color.accent,
            color: theme_1.DefaultTheme.color.accent
        },
        '&:active': {
            background: theme_1.DefaultTheme.background.active
        },
        '& i': {
            'padding-right': '4px'
        }
    },
    _a[exports.CSS.option.downloadDisabled] = {
        pointerEvents: 'none',
        opacity: 0.5
    },
    _a[exports.CSS.isOptionComplete] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[exports.CSS.isOptionIconComplete] = {
        color: 'green'
    },
    _a[exports.CSS.isTooManyCollections] = {
        padding: theme_1.DefaultTheme.space(4),
        'font-weight': 'bold'
    },
    _a[exports.CSS.csv.container] = {
        padding: theme_1.DefaultTheme.space(4),
        'align-items': 'center',
        'justify-content': 'space-between'
    },
    _a[exports.CSS.file.drop] = {
        height: '56px',
        width: '300px'
    },
    _a[exports.CSS.importButton] = {
        padding: theme_1.DefaultTheme.space(4),
        'text-align': 'right'
    },
    _a[exports.CSS.tabBar.container] = {
        padding: theme_1.DefaultTheme.space(4),
        display: 'flex'
    },
    _a[exports.CSS.tabBar.tab] = (_b = {
            position: 'relative',
            padding: "".concat(theme_1.DefaultTheme.space(4), " ").concat(theme_1.DefaultTheme.space(6)),
            'font-size': '120%',
            cursor: 'pointer',
            transition: '0.1s',
            overflow: 'hidden',
            userSelect: 'none',
            '&:after': {
                content: '""',
                position: 'absolute',
                bottom: '0',
                left: '0',
                display: 'block',
                width: '100%',
                height: '0px',
                background: theme_1.DefaultTheme.color.accent,
                transition: '0.1s'
            },
            '&:hover': {
                background: theme_1.DefaultTheme.background.lightGrey
            },
            '&:active': {
                background: theme_1.DefaultTheme.background.active
            }
        },
        _b["&:not(.".concat(exports.CSS.tabBar.tabActive, "):hover:after")] = {
            height: '2px'
        },
        _b),
    _a[exports.CSS.tabBar.tabActive] = {
        '&:after': {
            height: '4px'
        }
    },
    _a[exports.CSS.importNotifications.container] = {
        display: 'flex',
        'flex-direction': 'column',
        gap: '15px',
        '& > div > div': {
            display: 'flex',
            'align-items': 'center'
        },
        '& > div > div > .material-icons': {
            'margin-right': '4px'
        },
        '& td': {
            border: '1px solid #ccc',
            padding: '4px'
        },
        '& th': {
            border: '1px solid #ccc',
            padding: '4px'
        },
        '& tr': {
            border: '1px solid #ccc'
        },
        '& table': {
            border: '1px solid #ccc',
            'border-collapse': 'collapse'
        }
    },
    _a[exports.CSS.importNotifications.collectionLink] = {
        'margin-right': '4px'
    },
    _a));
//# sourceMappingURL=import.style.js.map